define(function (require) {
    "use strict";

    var Modernizr = require("modernizr.lineClamp");
    require("modernizr.isEdge");
    return Modernizr;
});
